import { useTickets, usePaginateTickets } from 'hooks/tickets';

import { Text } from '@chakra-ui/react';

import AsyncTable from 'components/Tables/AsyncTable';
import dateFormat from 'functions/dateFormat';

const columns = [
	{
		Header: 'Status',
		accessor: 'status'
	},
	{
		Header: 'Prioridade',
		accessor: 'priority'
	},
	{
		Header: 'Onde encontrou o erro?',
		accessor: 'error'
	},
	{
		Header: 'O que o erro causa?',
		accessor: 'description'
	},
	{
		Header: 'Aberto em',
		accessor: 'created_at',
		Cell: ({ value }) => <Text>{dateFormat(value)}</Text>
	}
];

const TableTicket = () => {
	const { rows, page, perPage, total } = useTickets();
	const [paginateTickets, { loading }] = usePaginateTickets();

	const fetchData = ({ pageSize, pageIndex, search }) => {
		if (pageSize !== perPage) pageIndex = 1;
		paginateTickets({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				search: search || ''
			}
		});
	};

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="suporte"
			noDelete
			linkRow
		/>
	);
};

export default TableTicket;
